import { Link } from 'react-router-dom'
import { MapPin, Phone, Mail } from 'lucide-react'

export default function Footer() {
    return (
        <footer className="bg-neutral-900 text-white py-12 w-full">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="md:col-span-2 lg:col-span-2">
                        <div className="flex items-center gap-3 mb-4">
                            <img
                                src="/images/logo/logo_petunya_borek.png"
                                alt="Petunya Börek"
                                className="h-10 w-auto"
                            />
                            <h3 className="text-2xl font-bold text-white">Petunya Börek</h3>
                        </div>
                        <p className="text-neutral-300 mb-6 max-w-md leading-relaxed">
                            Geleneksel lezzetleri özenle hazırlayarak, en taze ve kaliteli
                            börek çeşitlerini kapınıza kadar getiriyoruz.
                        </p>

                        {/* Social Media */}
                        <div className="mb-6">
                            <h4 className="text-sm font-semibold text-neutral-400 uppercase tracking-wider mb-4">
                                Bizi Takip Edin
                            </h4>
                            <div className="flex space-x-4">
                                <a
                                    href="https://www.facebook.com/Pb-Unlu-Mamüller-İmalatı-ve-Pazarlama-Ltd-Şti-390898711117932/?ref=bookmarks"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 bg-neutral-700 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors"
                                >
                                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                    </svg>
                                </a>
                                <a
                                    href="https://twitter.com/PetunyaBorek"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 bg-neutral-700 hover:bg-blue-400 rounded-full flex items-center justify-center transition-colors"
                                >
                                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                                        <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                                    </svg>
                                </a>
                                <a
                                    href="https://www.instagram.com/petunyaborek/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 bg-neutral-700 hover:bg-pink-500 rounded-full flex items-center justify-center transition-colors"
                                >
                                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4">İletişim</h4>
                        <div className="space-y-3 text-neutral-300">
                            <div className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary-400" />
                                <div className="text-sm">
                                    <div>Tevfikbey Mah. Avcılar Sok. No:2A</div>
                                    <div>Küçükçekmece, İstanbul</div>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <Phone className="w-4 h-4 flex-shrink-0 text-primary-400" />
                                <a
                                    href="tel:02126261131"
                                    className="hover:text-white transition-colors text-sm"
                                >
                                    (0212) 626 11 31
                                </a>
                            </div>
                            <div className="flex items-center gap-3">
                                <Mail className="w-4 h-4 flex-shrink-0 text-primary-400" />
                                <a
                                    href="mailto:pbunlumamuller@gmail.com"
                                    className="hover:text-white transition-colors text-sm break-all"
                                >
                                    pbunlumamuller@gmail.com
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Working Hours */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4">Çalışma Saatleri</h4>
                        <div className="space-y-3">
                            <div className="bg-neutral-800 rounded-lg p-4">
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-neutral-300">Her gün</span>
                                    <span className="text-white font-medium">08:00 – 23:00</span>
                                </div>
                            </div>
                            <p className="text-xs text-neutral-400 px-1">
                                Online siparişlerinizi 7/24 verebilirsiniz.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-neutral-700 mt-8 pt-8">
                    <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
                        <p className="text-neutral-400 text-sm text-center lg:text-left">
                            &copy; 2025 Petunya Börek - PB Unlu Mamüller İmalatı ve Pazarlama Ltd. Şti. Tüm hakları saklıdır.
                        </p>
                        <div className="flex flex-wrap justify-center lg:justify-end space-x-6 text-sm">
                            <Link
                                to="/kalite-politikasi"
                                className="text-neutral-400 hover:text-white transition-colors hover:underline"
                            >
                                Kalite Politikası
                            </Link>
                            <Link
                                to="/gizlilik"
                                className="text-neutral-400 hover:text-white transition-colors hover:underline"
                            >
                                Gizlilik Politikası
                            </Link>
                            <Link
                                to="/kullanim-kosullari"
                                className="text-neutral-400 hover:text-white transition-colors hover:underline"
                            >
                                Kullanım Koşulları
                            </Link>
                        </div>
                    </div>

                    {/* Ajans imzası */}
                    <p className="mt-6 text-center text-sm text-neutral-500">
                        Bu proje{' '}
                        <a
                            href="https://www.EloveAgency.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="elove-glow font-semibold hover:underline"
                        >
                            www.EloveAgency.com
                        </a>{' '}
                        tarafından yapılmıştır.
                    </p>
                </div>
            </div>
        </footer>
    )
}